import { render, staticRenderFns } from "./CoBookingResource.vue?vue&type=template&id=0f5c303f&scoped=true&"
import script from "./CoBookingResource.vue?vue&type=script&lang=ts&"
export * from "./CoBookingResource.vue?vue&type=script&lang=ts&"
import style0 from "./CoBookingResource.vue?vue&type=style&index=0&id=0f5c303f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c303f",
  null
  
)

export default component.exports